import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[documentDetailDirective]',
})
export class DocumentDetailDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}